export default "__VITE_ASSET__DocF9_IA__"